// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
// local
import t from 'app/lib/i18n';
// css
import './Notification.scss';

class Notification extends Component {
    render() {
        const { isError, message } = this.props;
        let css = `notification`;
        if (message !== null) {
            css += ' show';
        }
        let header = null;
        let content = null;
        let list = null;
        if (isError) {
            if (!message) {
                return null;
            }
            if (message.length > 1) {
                header = 'Alguns erros foram encontrados:';
                list = message.map(item => t(item.key, item.data));
            } else {
                const item = message[0];
                content = t(item.key, item.data);
            }
        } else {
            content = t(message);
        }
        return <Message className={css} header={header} error={isError} content={content} list={list} onDismiss={this.handleDismiss} />;
    }
}

Notification.propTypes = {
    isError: PropTypes.bool,
    message: PropTypes.any,
};

export default Notification;
